/**
 * @description  方法类   tools.js

 * importAll(modulesContext)           加载目录所有js文件对象
 * getCookie(name)                     获取cookie
 * setCookie(cname, cvalue, exdays)    设置cookie
 * deleteCookie(cname)                 删除cookie
 * getStorage(cname)                   获取localStorage
 * setStorage(cname,cvalue)            设置localStorage
 * removeStorage(cname)                删除localStorage
 * clearStorage()                      清除localStorage
 * getSession(cname)                   获取sessionStorage
 * setSession(cname,cvalue)            设置SessionStorage
 * removeSession(cname)                删除SessionStorage
 * clearSession()                      清除SessionStorage
 * uuidv4()                            生成 uuid
 * getQueryStringByName(name)          获取地址栏参数
 * stringFormat()                      String.format    stringFormat('a{0}{1}',200,300)
 * getRangeSixMonth()                  获取前六个月范围   return '3-8'
 * formatNumber(num)                   格式化数字，添加千位分隔符
 * zeroFill(num)                       小数点后两位，补零
 * GetAge(birthday)                    根据生日获取周岁
 */

const fileNameRE = /^\.\/([^\s]+)\.js$/;
export const importAll = modulesContext => {
  return modulesContext.keys().map(modulesPath => {
    const moduleName = modulesPath.match(fileNameRE);
    return {
      moduleName,
      camelModuleName: moduleName[1].replace(/-(\w)/g, (_, c) =>
        c ? c.toUpperCase() : ""
      ),
      module: modulesContext(modulesPath).default
    };
  });
};

export const IsPC = () => {
  var userAgentInfo = navigator.userAgent;
  var Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod"
  ];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
};

/**
 * 获取cookie
 *  */
export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
/**
 * 设置cookie
 */
export function setCookie(cname, cvalue, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie =
    cname +
    "=" +
    cvalue +
    ";" +
    expires +
    ";path=/;domain=" +
    process.env.VUE_APP_COOKIE_DOMAIN;
}
/**
 * 删除cookie
 */
export function deleteCookie(name) {
  // document.cookie = name + '=; domain=.koofenqi.com; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;';
  setCookie(name, "", -1);
}
/**
 * 生成uuidV4
 */
export function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    let r = (Math.random() * 16) | 0;
    let v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * 获取URL中的参数
 * @param {String} name - 参数名称
 * @author lxl
 * @example let param = getQueryStringByName("name")
 *
 */
export const getQueryStringByName = (name, location) => {
  let _str = "";
  if (location && location.indexOf("?") >= 0) {
    _str = location.split("?")[1];
  } else {
    _str = window.location.search.substr(1);
  }
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  let r = _str.match(reg);
  let context = "";
  if (r != null) context = r[2];
  reg = null;
  r = null;
  return context === null || context === "" || context === "undefined"
    ? ""
    : context;
};

export function assert(condition, msg) {
  if (!condition) throw new Error(`[Apior] ${msg}`);
}

/**
 * String.format
 * @example  stringFormat('a{0}{1}',200,300)    'a200300'
 */
export function stringFormat() {
  if (arguments.length === 0) {
    return null;
  }
  let str = arguments[0];
  for (let i = 1; i < arguments.length; i++) {
    let re = new RegExp("\\{" + (i - 1) + "\\}", "gm");
    str = str.replace(re, arguments[i]);
  }
  return str;
}

export const getStorage = function(key) {
  try {
    let value = localStorage.getItem(key);
    if (value) {
      try {
        let value_json = JSON.parse(value);
        if (typeof value_json === "object") {
          return value_json;
        } else if (typeof value_json === "number") {
          return value_json;
        }
      } catch (e) {
        return value;
      }
    } else {
      return "";
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
};
export const setStorage = function(key, value) {
  try {
    localStorage.setItem(key, value);
    // eslint-disable-next-line no-empty
  } catch (e) {}
};
export const removeStorage = function(key) {
  try {
    localStorage.removeItem(key);
    // eslint-disable-next-line no-empty
  } catch (e) {}
};
export const clearStorage = function() {
  try {
    localStorage.clear();
    // eslint-disable-next-line no-empty
  } catch (e) {}
};
export const getSession = function(key) {
  if (window.sessionStorage) {
    let value = window.sessionStorage.getItem(key);
    if (value) {
      try {
        let value_json = JSON.parse(value);
        if (typeof value_json === "object") {
          return value_json;
        } else if (typeof value_json === "number") {
          return value_json;
        }
      } catch (e) {
        return value;
      }
    } else {
      return "";
    }
  } else {
    getCookie(key);
  }
};
export const setSession = function(key, value) {
  if (window.sessionStorage) {
    window.sessionStorage.setItem(key, value);
  } else {
    setCookie(key, value, 1);
  }
};
export const removeSession = function(key) {
  if (window.sessionStorage) {
    window.sessionStorage.removeItem(key);
  } else {
    deleteCookie(key);
  }
};
export const clearSession = function() {
  sessionStorage.clear();
};
export const getRangeSixMonth = function() {
  let date = new Date();
  let lastMonth = date.getMonth() || 12;
  let beginMonth = lastMonth - 5;
  if (beginMonth <= 0) beginMonth += 12;
  return beginMonth + "-" + lastMonth;
};

export const zeroFill = function(num) {
  let value = num;
  let xsd = value.toString().split(".");
  if (xsd.length === 1) {
    value = value.toString() + ".00";
    return value;
  }
  if (xsd.length > 1) {
    if (xsd[1].length < 2) {
      value = value.toString() + "0";
    }
    return value;
  }
};

export const formatNumber = function(num) {
  if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(num)) {
    return num;
  }
  let a = RegExp.$1;
  let b = RegExp.$2;
  let c = RegExp.$3;
  let re = new RegExp("(\\d)(\\d{3})(,|$)");
  while (re.test(b)) {
    b = b.replace(re, "$1,$2$3");
  }
  return String(String(a) + b) + c;
};

// 复制对象中属性相同的值
export const copyObj = function(dest, source) {
  for (let key of Object.keys(dest)) {
    if (source !== null && source[key] !== null && source[key] !== undefined) {
      dest[key] = source[key];
    }
  }
};

// 是否时iOS13
export const isIOS13 = function() {
  const ua = navigator.userAgent.toLowerCase();
  const uastr = ua.match(/cpu iphone os (.*?) like mac os/);
  let ver = [];
  if (uastr) {
    ver = uastr[1].split("_");
  }
  return Number(ver[0]) === 13;
};

// 日期格式化
export const fomatDate = function(date, fmt = "yyyy-MM-dd") {
  let addZero = function(num) {
    if (typeof num === "number") {
      if (num < 10) {
        return "0" + num;
      }
      return String(num);
    } else {
      return null;
    }
  };
  let yyyy = date.getFullYear();
  let MM = date.getMonth();
  let dd = date.getDate();
  let HH = date.getHours();
  let mm = date.getMinutes();
  let ss = date.getSeconds();
  let hh = HH > 12 ? HH - 12 : HH;
  let dateStr = fmt
    .replace("yyyy", yyyy)
    .replace("MM", addZero(MM + 1))
    .replace("dd", addZero(dd))
    .replace("HH", addZero(HH))
    .replace("mm", addZero(mm))
    .replace("ss", addZero(ss))
    .replace("hh", addZero(hh));
  return dateStr;
};

export const isEmpty = function(val, includeZero = false) {
  return (
    val === "" ||
    val === null ||
    val === undefined ||
    (includeZero && val === 0)
  );
};

export const cutNumber = function(val, digits) {
  if (isEmpty(val)) {
    return 0;
  } else {
    if (Number.isInteger(val)) {
      return val.toFixed(digits);
    }
    let str_val = String(val);
    let strArr = str_val.split(".");
    if (strArr.length === 1) {
      strArr[1] = "".padEnd(digits, 0);
    } else {
      if (strArr[1].length > digits) {
        strArr[1] = strArr[1].substr(0, digits);
      } else {
        strArr[1] = strArr[1].padEnd(digits, 0);
      }
    }
    return strArr.join(".");
  }
};

export const GetAge = function(strBirthday) {
  if (!strBirthday) return null;
  var returnAge,
    strBirthdayArr = strBirthday.split("-"),
    birthYear = strBirthdayArr[0],
    birthMonth = strBirthdayArr[1],
    birthDay = strBirthdayArr[2],
    d = new Date(),
    nowYear = d.getFullYear(),
    nowMonth = d.getMonth() + 1,
    nowDay = d.getDate();
  if (nowYear == birthYear) {
    returnAge = 0; //同年 则为0周岁
  } else {
    var ageDiff = nowYear - birthYear; //年之差
    if (ageDiff > 0) {
      if (nowMonth == birthMonth) {
        var dayDiff = nowDay - birthDay; //日之差
        if (dayDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      } else {
        var monthDiff = nowMonth - birthMonth; //月之差
        if (monthDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      }
    } else {
      returnAge = -1; //返回-1 表示出生日期输入错误 晚于今天
    }
  }
  return returnAge; //返回周岁年龄
};

//获取地区显示
export const getLabels = values => {
  let ret = [];
  try {
    let _objProvinces = window.division.find(o => o.value === values[0]);
    if (!_objProvinces) {
      return "";
    }
    let _city = _objProvinces.children.find(o => o.value === values[1]);
    let _area = _city.children.find(o => o.value === values[2]);
    if (_objProvinces) ret.push(_objProvinces.label);
    if (_city) ret.push(_city.label);
    if (_area) ret.push(_area.label);
    return ret.join(" ");
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const dateFormat = fmt => {
  let date = new Date();
  var o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

export const getId = str => {
  if (!str) return "";
  if (str.indexOf("-") === -1) {
    return str;
  } else {
    return str.split("-")[1];
  }
};

//判断当前页面是在ios还是安卓 百度app中打开
function isAndroidOrIOS() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) {
    return "android";
  }
  if (isiOS) {
    return "ios";
  }
  return false;
}
//android
function shareBaiduEventAndroid(options) {
  prompt(
    "BdboxApp:" +
      JSON.stringify({
        obj: "Bdbox_android_utils",
        func: "callShare",
        args: [
          `{
			imageUrl: "${options.imageUrl}",
			mediaType: "weixin_timeline",
			title: "${options.title}",
			content: "${options.content}",
			linkUrl: "${options.linkUrl}",
			iconUrl: "${options.iconUrl}"
			}`,
          "window.NativeShareSuccessCallback",
          "window.NativeShareFailCallback"
        ]
      })
  );
}
function shareBaiduEventIos(options) {
  let url = "";
  try {
    //百度app(ios) H5一键分享到朋友圈等
    url =
      "baiduboxapp://callShare?" +
      [
        "options=" +
          encodeURIComponent(
            JSON.stringify({
              title: options.title, //标题
              imageUrl: options.imageUrl,
              mediaType: "weixin_timeline", //分享类型  all:调起分享选择框，weixin_timeline：直接到朋友圈,weixin_friend:好友，qqfriend ：qq好友
              content: options.content, //分享内容
              linkUrl: options.linkUrl, //地址
              iconUrl: options.iconUrl //图标
            })
          ),
        "errorcallback=window.NativeShareFailCallback",
        "successcallback=window.NativeShareSuccessCallback"
      ].join("&");
  } catch (e) {
    console.log(e);
  }
  window.location.href = url;
}
function shareUcEventAndroid(options) {
  // eslint-disable-next-line no-undef
  ucweb.startRequest("shell.page_share", [
    options.title,
    options.content,
    options.linkUrl,
    "WechatTimeline",
    "",
    options.from || "",
    options.iconUrl
  ]);
}
function shareUcEventIos(options) {
  // eslint-disable-next-line no-undef
  if (ucbrowser.web_shareEX) {
    // eslint-disable-next-line no-undef
    ucbrowser.web_shareEX(
      JSON.stringify({
        title: options.title,
        content: options.content,
        sourceUrl: options.linkUrl,
        imageUrl: options.iconUrl,
        source: options.from || "",
        target: "kWeixinFriend"
      })
    );
  } else {
    // eslint-disable-next-line no-undef
    ucbrowser.web_share(
      options.title,
      options.content,
      options.linkUrl,
      "kWeixinFriend",
      "",
      options.from,
      ""
    );
  }
}
function shareOtherEvent() {
  window.location.href = "weixin://";
}
//百度app分享
export const baiduAppShare = options => {
  var u = navigator.userAgent;
  var isBaiduApp = /baiduboxapp/i.test(u);
  const isUCMBrowser = /UCBrowser/i.test(u);
  let type = isAndroidOrIOS();
  if (type === "android") {
    if (isBaiduApp) {
      shareBaiduEventAndroid(options);
    } else if (isUCMBrowser) {
      shareUcEventAndroid(options);
    } else {
      shareOtherEvent();
    }
  } else if (type === "ios") {
    if (isBaiduApp) {
      shareBaiduEventIos(options);
    } else if (isUCMBrowser) {
      shareUcEventIos(options);
    } else {
      shareOtherEvent();
    }
  } else {
    shareOtherEvent();
  }
};
